import { ThemeProvider as ThemeVarsProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme } from "./create-theme";

// ----------------------------------------------------------------------

export function ThemeProvider({
	children,
	brand = "batt-b2b",
}: {
	children: React.ReactNode;
	brand?: "batt-b2b" | "batt-b2c" | "ethias-lease";
}) {
	// TODO: put back after demo
	const theme = createTheme(brand);

	return (
		<ThemeVarsProvider
			disableTransitionOnChange
			theme={theme}
			defaultMode="light"
			modeStorageKey="mui-color-scheme"
		>
			<CssBaseline />
			{children}
		</ThemeVarsProvider>
	);
}
